export const services = [
  {
    title: "real estate investment solutions",
    description:
      "Discover high-ROI investment opportunities in prime real estate markets. Our investment solutions cater to individuals and corporate investors looking for secure and profitable real estate ventures. Whether you're interested in off-plan investments, rental income properties, or land banking, we provide well-researched, high-growth opportunities with detailed financial projections and risk analysis to maximize your returns",
    image: "/images/service/estate site plan.svg",
  },
  {
    title: "Architectural Design and Planning",
    description:
      "Our expert architects create innovative and functional property designs tailored to modern living. We focus on aesthetics, sustainability, and space optimization, ensuring each project blends seamlessly with its environment. From concept sketches to full-scale blueprints and 3D renderings, we provide a creative yet practical approach to design, giving clients a clear vision before execution begins",
    image: "/images/home/Architectural_Design.svg",
  },
  {
    title: "Construction and Project Management",
    description:
      "We handle everything from land acquisition to project execution, ensuring top-tier quality and timely delivery. Our experienced team of engineers, architects, and project managers work closely to ensure structural integrity, compliance with industry standards, and seamless workflow from foundation to finishing. Whether it's a residential, commercial, or luxury development, we deliver projects that stand the test of time",
    image: "/images/service/construction and management image.svg",
  },
  {
    title: "Interior Design and Fixtures Production",
    description:
      "We transform spaces with custom interiors, luxury finishes, and high-end fixtures. Our interior design solutions cater to homeowners, businesses, and investors seeking a refined and stylish touch. From furniture selection to lighting, color palettes, and bespoke fixture production, we craft interiors that reflect elegance, functionality, and comfort while maintaining durability and quality craftsmanship",
    image: "/images/service/Interior design.svg",
  },
  {
    title: "Site Preparation and Land Development",
    description:
      "We provide land clearing, infrastructure setup, and site development for smooth project execution. Our services include environmental assessments, grading, excavation, utility installations, and foundation preparation. We ensure that land is optimized for construction, minimizing risks and maximizing the structural stability of future developments. Whether for residential estates, commercial projects, or industrial facilities, we set the groundwork for success",
    image: "/images/service/excavation_image.svg",
  },
  {
    title: "Consultation and Advisory Services",
    description:
      "Need expert real estate guidance? Our professionals are here to help. We offer tailored real estate consultation for homebuyers, investors, and developers, providing market insights, investment strategies, and personalized recommendations. Whether you're purchasing your first home, looking for property development advice, or seeking to expand your investment portfolio, our team ensures you make informed and profitable ",
    image: "/images/service/consultation_image.svg",
  },
  {
    title: "Facility Management",
    description:
      "AREL’s Facility Management services ensure that properties remain well-maintained, secure, and operationally efficient. From routine maintenance and technical services to security management and cleaning, AREL provides end-to-end solutions for residential and commercial properties. With a focus on asset preservation and sustainability, our team handles everything from HVAC systems, plumbing, and electrical maintenance to security surveillance and janitorial services. We take a proactive approach to property management, ensuring that both investors and residents enjoy seamless, worry-free ownership.",
    image: "/images/service/Facility management.svg",
  },
];

export const whyData = [
  {
    img: "shield-tick.svg",
    head: "Proven Track Record",
    desc: "We have successfully developed multiple premium real estate projects, delivering high-quality homes and investment opportunities",
  },
  {
    img: "shield-tick.svg",
    head: "Customer-Centric Approach",
    desc: "We prioritize our clients' needs by offering tailored solutions, flexible payment plans, and expert real estate advisory services",
  },
  {
    img: "shield-tick.svg",
    head: "Strong Investment Returns",
    desc: "Our real estate investment opportunities provide secure, high-yield returns backed by market research and expert analysis",
  },
  {
    img: "shield-tick.svg",
    head: "Comprehensive Real Estate Solutions",
    desc: "From land acquisition to interior design and investment consulting, we offer an all-in-one real estate service package",
  },
];

export const team = [
  {
    image: "/images/about/olivia rhye.svg",
    name: "Olivia Rhye",
    position: "Founder & CEO",
    role: "Former co-founder of Opendoor. Early staff at Spotify and Clearbit.",
    twitter: "#",
    linkedin: "#",
    instagram: "#",
  },
  {
    image: "/images/about/olivia rhye.svg",
    name: "Olivia Rhye",
    position: "Founder & CEO",
    role: "Former co-founder of Opendoor. Early staff at Spotify and Clearbit.",
    twitter: "#",
    linkedin: "#",
    instagram: "#",
  },
  {
    image: "/images/about/olivia rhye.svg",
    name: "Olivia Rhye",
    position: "Founder & CEO",
    role: "Former co-founder of Opendoor. Early staff at Spotify and Clearbit.",
    twitter: "#",
    linkedin: "#",
    instagram: "#",
  },
  {
    image: "/images/about/olivia rhye.svg",
    name: "Olivia Rhye",
    position: "Founder & CEO",
    role: "Former co-founder of Opendoor. Early staff at Spotify and Clearbit.",
    twitter: "#",
    linkedin: "#",
    instagram: "#",
  },
];

export const blog = [
  {
    image: "images/about/Blog1.svg",
    title: "Press Release",
    description: "AREL Expands Its Luxury Smart Home.",
    twitter: "https://twitter.com/",
    instagram: "https://instagram.com/",
    linkedin: "https://instagram.com/",
  },
  {
    image: "images/about/Blog 2.svg",
    title: "Market Insight Report",
    description: "Real Estate Trends 2024:Lagos the Next Big",
    twitter: "https://twitter.com/",
    instagram: "https://instagram.com/",
    linkedin: "https://instagram.com/",
  },
  {
    image: "images/about/Blog 3.svg",
    title: "Project History",
    description: "Inside AREL’s Landmark Project",
    twitter: "https://twitter.com/",
    instagram: "https://instagram.com/",
    linkedin: "https://instagram.com/",
  },
];
export const reasonData = [
  {
    img: "ble.svg",
    desc: "With a steadily growing portfolio and numerous successful property transactions, we are committed to delivering premium real estate solutions",
    head: "Building a Legacy of Excellence",
  },
  {
    img: "mri.svg",
    desc: "Strategically chosen properties in high-growth areas ensure lucrative returns",
    head: "Maximized Returns for Investors",
  },
  {
    img: "lsd.svg",
    desc: "We ensure end-to-end legal compliance and provide clear investment documentation",
    head: "100% Legal & Secure Deals",
  },
  {
    img: "blc.svg",
    desc: "We design contemporary, high-quality homes tailored to modern living",
    head: "Built for Luxury & Comfort",
  },
];

export const next = [
  {
    image: "/images/consultation/email icon.svg",
    title: "Step 1:Email confirmation",
    description:
      "You’ll receive an email with your consultation details, including date, time, and meeting format (virtual or in-person)",
  },
  {
    image: "/images/consultation/call icon.svg",
    title: "Step 2:Team follow-up",
    description:
      "Our team will call or email you within 24 hours to confirm your appointment, discuss your real estate needs, and provide any necessary documents or pre-meeting materials.",
  },
  {
    image: "/images/consultation/consultation icon.svg",
    title: "Step 3:Attend your consultation",
    description:
      "On your scheduled date, meet with our experts for a one-on-one discussion. Whether you’re buying, investing, or developing, we’ll provide tailored solutions to guide your real estate journey",
  },
];
